import SwipeableContainer from './SwipeableContainer';

export default SwipeableContainer;
